'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CamOverlay = function CamOverlay(_ref) {
  var backgroundImage = _ref.backgroundImage;
  return _react2.default.createElement('div', { style: { backgroundImage: backgroundImage }, className: 'quiver-cam-overlay' });
};

CamOverlay.propTypes = {
  backgroundImage: _propTypes2.default.string
};

CamOverlay.defaultProps = {
  backgroundImage: null
};

exports.default = CamOverlay;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamOverlay/CamOverlay.js
// module id = 537
// module chunks = 11